import "./App.css";
import { useState, useEffect } from "react";
import Blogs from "./components/Blogs";
import OurClient from "./components/Client/OurClient";
import Gallery from "./components/Gallery/Gallery";
import Header from "./components/Header";
import WhyUs from "./components/WhyUs";
import Footer from "./components/Footer/Footer.js";
import Services from "./components/Services/Services";
import EventCat from "./components/EventCat/EventCat";
import ClientFeedback from "./components/Client/ClientFeedback";
import FAQ from "./components/FAQ/FAQ";
import ScrollTop from "./components/ScrollToTop/ScrollTop";
import { BlogIdProvider } from "./Context/BlogIdContext";
import CreateWhatsappChatWidget from "./components/WhatsAppIcon";

function App() {
  const [eventImage, setEventImage] = useState("All");

  const [classUpdate, setClassUpdate] = useState("All");

  const listenScrollEvent = () => {
    window.scrollY > 100
      ? (document.getElementById("return-to-top").style.display = "grid")
      : // setnavColor("#252734")
        (document.getElementById("return-to-top").style.display = "none");
  };
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  var url =
    "https://wati-integration-service.clare.ai/ShopifyWidget/shopifyWidget.js?3023";
  var s = document.createElement("script");
  s.type = "text/javascript";
  s.async = true;
  s.src = url;
  var options = {
    enabled: true,
    chatButtonSetting: {
      backgroundColor: "#4dc247",
      ctaText: "",
      borderRadius: "25",
      marginLeft: "0",
      marginBottom: "50",
      marginRight: "50",
      position: "right",
    },
    brandSetting: {
      brandName: "SKYLARK",
      brandSubTitle: "Typically replies within a day",
      brandImg:
        "https://skylark-website-images.s3.ap-south-1.amazonaws.com/logo_res.png",
      welcomeText: "Hi there!\nHow can I help you?",
      messageText:
        "Hello team SKYLARK, I have an upcoming event.\nWhen can we schedule a meeting to discuss the details and requirements?",
      backgroundColor: "#8e0405",
      ctaText: "Start Chat",
      borderRadius: "25",
      autoShow: false,
      phoneNumber: "916201811075",
    },
  };
  s.onload = function () {
    CreateWhatsappChatWidget(options);
  };
  var x = document.getElementsByTagName("script")[0];
  x.parentNode.insertBefore(s, x);

  return (
    <BlogIdProvider>
      <div className="page_container App">
        <Header
          eventImage={eventImage}
          setEventImage={setEventImage}
          classUpdate={classUpdate}
          setClassUpdate={setClassUpdate}
        />
        <WhyUs />
        <OurClient />
        <EventCat />
        <Services />
        <ScrollTop />
        <Blogs />
        <Gallery
          eventImage={eventImage}
          setEventImage={setEventImage}
          classUpdate={classUpdate}
          setClassUpdate={setClassUpdate}
        />
        <ClientFeedback />
        <FAQ />
        <Footer />
      </div>
    </BlogIdProvider>
  );
}

export default App;
